export const startupWizardAutoIdPrefix = 'startup_wizard';
export const getTabAutoId = (tab) => (field) =>
  `${startupWizardAutoIdPrefix}:${tab}:${field}`;
